import {createContext} from "react";
import QRCodeKind from "../../../api/qr-code/QRCodeKind";
import QRCode from "../../../api/qr-code/QRCode";
import CreatePayload from "../../../api/qr-code/CreatePayload";

export type CreateQRCodeStep = 'choose-kind' | 'input-data';

type CreateQRCodeContextType = {
    /**
     * Selected QRCode kind.
     * @author Kacper Faber
     * @since 0.1.8
     */
    kind: QRCodeKind | null;

    /**
     * Change selected QRCode kind.
     * @author Kacper Faber
     * @since 0.1.8
     * @param kind
     */
    setKind: (kind: QRCodeKind | null) => void;

    /**
     * Name of QRCode to be created.
     * @author Kacper Faber
     * @since 0.1.8
     */
    name: string | undefined;

    /**
     * @author Kacper Faber
     * @since 0.1.8
     * @param name
     */
    setName: (name: string | undefined) => void;

    /**
     * Check if given payload is valid.
     * You can show 'create' button etc. if data is valid.
     * @author Kacper Faber
     * @since 0.1.8
     */
    isValid: () => boolean;

    /**
     * Create QRCode.
     * @example
     * create().then((code) => ...).catch();
     * @author Kacper Faber
     * @since 0.1.8
     */
    create: () => Promise<QRCode>;

    /**
     * Create QR code step.
     * - choose-kind
     * - input-data
     * @author Kacper Faber
     * @since 0.1.8
     */
    step: CreateQRCodeStep;

    setStep: (s: CreateQRCodeStep) => void;

    /**
     * Payload to be sent.
     * @author Kacper Faber
     * @since 0.1.8
     */
    payload: CreatePayload;

    /**
     * Update payload
     * @param payload
     */
    setPayload: (payload: CreatePayload) => void;
};

const notImplemented = () => {
    throw new Error('Not implemented at this point.');
}



/**
 * Default value for context
 * @author Kacper Faber
 * @since 0.1.8
 */
const defaults: CreateQRCodeContextType = {
    kind: null,
    name: undefined,
    step: 'choose-kind',
    payload: { kind: 'website', name: 'test', key: 'test-12345' }, // TODO: Default payload.
    setPayload: notImplemented,
    setStep: notImplemented,
    setKind: notImplemented,
    setName: notImplemented,
    isValid: notImplemented,
    create: notImplemented
};

/**
 * Create QR code context.
 * @author Kacper Faber
 * @since 0.1.8
 */
const ctx = createContext<CreateQRCodeContextType>(defaults);

export default ctx;